import { AiOutlineHome } from "react-icons/ai";
import { FaBarcode } from "react-icons/fa";
import { IconType } from "react-icons";
import { MdSettingsBackupRestore } from "react-icons/md";
import { RiHeadphoneLine } from "react-icons/ri";

import FacebookIcon from "assets/icons/facebook-round.svg";
import InstagramIcon from "assets/icons/instagram-round.svg";
import LinkedinIcon from "assets/icons/linkedin-round.svg";
import YoutubeIcon from "assets/icons/youtube-round.svg";

type Page = {
  name: string;
  slug: string[];
  key: string;
  icon?: IconType;
  url?: string;
  ariaLabel?: string;
  showLink: boolean;
  param?: string;
  type?: string;
  subMenu?: Page[];
};

export const pages = (selectedUnit): Page[] => {
  return [
    {
      name: "Início",
      slug: ["inicio"],
      key: "inicio",
      icon: AiOutlineHome,
      url: "portal",
      ariaLabel: "Página inicial",
      showLink: true,
    },
    {
      name: "Boletos",
      slug: [
        "consulta-debitos",
        "debito-automatico",
        "preferencia-cobranca",
        "consumo",
      ],
      key: "boletos",
      icon: FaBarcode,
      showLink: true,
      subMenu: [
        {
          name: "Histórico de boletos",
          slug: ["consulta-debitos"],
          key: "consulta-debitos",
          url: "consulta-debitos",
          ariaLabel: "Página de Histórico de boletos",
          showLink: true,
        },
        {
          name: "Débito automático",
          slug: ["debito-automatico"],
          key: "debito-automatico",
          url: "debito-automatico",
          ariaLabel: "Página de débito automático",
          showLink: true,
        },
        {
          name: "Preferência de cobrança",
          slug: ["preferencia-cobranca"],
          key: "preferencia-cobranca",
          url: "preferencia-cobranca",
          ariaLabel: "Página de Preferência de cobrança",
          showLink: selectedUnit?.hasCurrentHouseholder,
        },
        {
          name: "Consumo",
          slug: ["consumo"],
          key: "consumo",
          url: "consumo",
          ariaLabel: "Página de Consumo",
          showLink: true,
        },
      ],
    },
    {
      name: "Ligar e desligar gás",
      slug: ["religue"],
      key: "religue",
      icon: MdSettingsBackupRestore,
      url: "religue",
      ariaLabel: "Página de solicitação de religue",
      showLink: selectedUnit?.hasCurrentHouseholder,
    },
    // {
    //   name: "Dados Cadastrais",
    //   slug: ["dados-cadastrais", "meus-dados", "minha-unidade"],
    //   key: "dados-cadastrais",
    //   icon: CgProfile,
    //   showLink: true,
    //   subMenu: [
    //     {
    //       name: "Meus dados",
    //       slug: ["meus-dados"],
    //       key: "meus-dados",
    //       url: "meus-dados",
    //       ariaLabel: "Página de meus dados",
    //       showLink: true,
    //     },
    //     {
    //       name: "Minha unidade",
    //       slug: ["minha-unidade"],
    //       key: "minha-unidade",
    //       url: "minha-unidade",
    //       ariaLabel: "Página minha unidade",
    //       showLink: selectedUnit?.hasCurrentHouseholder,
    //     },
    //   ],
    // },
    {
      name: "Fale conosco",
      slug: ["contato"],
      key: "fale-conosco",
      icon: RiHeadphoneLine,
      url: "fale-conosco",
      ariaLabel: "Página fale conosco",
      showLink: true,
    },
  ];
};

export const socials = [
  {
    img: FacebookIcon,
    alt: "Facebook",
    href: "https://www.facebook.com/ultragazoficial/",
  },
  {
    img: YoutubeIcon,
    alt: "Youtube",
    href: "https://www.youtube.com/user/UltragazBrasilgas",
  },
  {
    img: InstagramIcon,
    alt: "Instagram",
    href: "https://www.instagram.com/ultragazoficial/",
  },
  {
    img: LinkedinIcon,
    alt: "Linkedin",
    href: "https://www.linkedin.com/company/ultragaz/mycompany/",
  },
];
